import React, { useState }    from 'react';
import PropTypes              from 'prop-types';
import { isEmpty, findIndex } from 'lodash';

import { updateCommunityOnboarding } from '~/../components/shared/utils/api';
import validate                      from './validations';

import OnboardingMenu from './onboarding_menu';
import SetupCommunity from './setup_community';
import SetupPaywall   from './setup_paywall';
import InviteMembers  from './invite_members';
import Engagement     from './engagement';
import Leadership     from './leadership';

const menuOptions = [
  { id: 'setup', label: 'Setup Community', component: SetupCommunity },
  // { id: 'paywall', label: 'Setup Paywall', component: SetupPaywall },
  { id: 'members', label: 'Invite Members', component: InviteMembers },
  // { id: 'engagement', label: 'Kickstart Engagement', component: Engagement },
  // { id: 'leadership', label: 'Join Leadership Community', component: Leadership }
]

const Index = ({ initCommunity, pageParams }) => {
  const [params, setParams] = useState(pageParams);
  const [formData, setFormData] = useState(initCommunity);
  const [files, setFiles] = useState([]);
  const [errors, setErrors] = useState({});
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    !isEmpty(params.stripe_success) ? 'paywall' : 'setup'
  );
  const OptionComponent = menuOptions.find(option => option.id === selectedOption).component;

  const handleFieldChange = e => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
    setErrors(validate({ ...formData, [name]: value }));
    setIsFormChanged(true);
  }

  const handleChangeTab = tabName => {
    if (!isEmpty(errors)) return;

    if (tabName) setSelectedOption(tabName);
    else {
      const index = findIndex(menuOptions, option => option.id === selectedOption);
      setSelectedOption(menuOptions[index + 1].id);
    }

    if(isFormChanged) updateCommunityOnboarding(formData, files, handleSaveSuccess);
    setParams({});
  }

  const handleSetFile = file => {
    setFiles(file);
    setIsFormChanged(true);
  }

  const handleSaveSuccess = community => {
    setFormData(community);
    setFiles([]);
    setIsFormChanged(false);
    $('#community-img').attr('src', community.image_url + Math.random());
  }

  return (
    <div className='row onboarding-container'>
      <OnboardingMenu selectedOption={selectedOption} handleChangeTab={handleChangeTab}/>
      <div className='col-sm-9 option-container'>
        <OptionComponent
          formData={formData}
          setFormData={setFormData}
          handleFieldChange={handleFieldChange}
          handleChangeTab={handleChangeTab}
          handleSetFile={handleSetFile}
          files={files}
          errors={errors}
          params={params}
        />

        {(selectedOption != 'members') &&
          <button
            className={`btn btn-main mt-20 mb-20 ml-20 ${isEmpty(errors) ? '' : 'disabled'}`}
            onClick={() => handleChangeTab()}
          >
          Continue
        </button>}
      </div>
    </div>
  );
};

Index.propTypes = {
  initCommunity: PropTypes.object.isRequired,
  params: PropTypes.object
};

export default Index;
